import React, {
  useEffect,
  useState
} from "react";

import { useNavigate } from "react-router-dom";

//import approvalService from "../services/approvalService";
import approvalService from "../services/approvalService";
import {
  formatDate,
  formatQuantity
} from "../../../../utils/formatUtils";

//import POViewDrawer from "../../material_flow/procurement/purchase_order/POViewDrawer";
import POViewDrawer from "../../pages/procurement/purchaseOrder/POViewDrawer";

const MyApprovalsPage = () => {

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [selectedPO, setSelectedPO] =
    useState(null);

  const [showView, setShowView] =
    useState(false);

  const [showActionModal, setShowActionModal] =
    useState(false);

  const [actionType, setActionType] =
    useState("");

  const [selectedTransaction, setSelectedTransaction] =
    useState(null);

  const [remarks, setRemarks] =
    useState("");
  const navigate = useNavigate();

  const loadData = async () => {

    try {

      setLoading(true);

      const res =
        await approvalService
          .getPendingApprovals();

      if (res.success) {

        setRows(
          res.data || []
        );

      }

    } catch (err) {

  console.error(err);

  alert(
    err?.message ||
    "Operation failed"
  );

} finally {

      setLoading(false);

    }

  };

  useEffect(() => {

    loadData();

  }, []);

  const summary = {

    pending: rows.length

  };

  const filtered = rows.filter((r) => {

    const keyword =
      search.toLowerCase();

    return (

      r.entity_number
        ?.toLowerCase()
        .includes(keyword)

      ||

      r.approval_name
        ?.toLowerCase()
        .includes(keyword)

      ||

      r.module_code
        ?.toLowerCase()
        .includes(keyword)

      ||

      r.entity_name
        ?.toLowerCase()
        .includes(keyword)

    );

  });
    const openApproveModal = (row) => {

    setSelectedTransaction(row);

    setActionType("APPROVE");

    setRemarks("");

    setShowActionModal(true);

  };

  const openRejectModal = (row) => {

    setSelectedTransaction(row);

    setActionType("REJECT");

    setRemarks("");

    setShowActionModal(true);

  };

  const handleView = (row) => {

    if (
      row.entity_name ===
      "PURCHASE_ORDER"
    ) {

      setSelectedPO(
        row.entity_id
      );

      setShowView(true);
       return;
    }

    if (row.entity_name === "INDENT") {

    navigate(
      `/ppe/procurement/indent/${row.entity_id}`
    );

    return;
  }

  };

  const handleAction = async () => {

    try {

      if (
        actionType ===
        "REJECT"
      ) {

        if (
          !remarks.trim()
        ) {

          alert(
            "Remarks are required"
          );

          return;

        }

      }

      if (
        actionType ===
        "APPROVE"
      ) {

        await approvalService
          .approve(
            selectedTransaction.transaction_id,
            remarks
          );

        alert(
          "Approval completed successfully"
        );

      }

      if (
        actionType ===
        "REJECT"
      ) {

        await approvalService
          .reject(
            selectedTransaction.transaction_id,
            remarks
          );

        alert(
          "Transaction rejected successfully"
        );

      }

      setShowActionModal(
        false
      );

      setSelectedTransaction(
        null
      );

      setRemarks("");

      loadData();

    }catch (err) {

      alert(
        err?.response?.data?.message ||
        err?.message ||
        "Action failed"
      );

    }

  };

  return (

    <div>

      {/* HEADER */}

      <div
        style={{
          background:
            "linear-gradient(90deg, #0f766e 0%, #14b8a6 50%, #5eead4 100%)",
          borderRadius: 12,
          padding: "16px 20px",
          color: "#fff",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >

        <div>

          <h4
            style={{
              margin: 0
            }}
          >
            My Approvals
          </h4>

          <div
            style={{
              fontSize: 13,
              opacity: 0.9
            }}
          >
            Pending approval transactions assigned to me
          </div>

        </div>

        <button
          className="btn btn-light"
          onClick={loadData}
        >
          Refresh
        </button>

      </div>

      {/* KPI */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(1, 1fr)",
          gap: 10,
          marginBottom: 20
        }}
      >

        <div
          style={{
            background: "#fff",
            padding: 15,
            borderRadius: 8,
            borderLeft:
              "4px solid #14b8a6"
          }}
        >

          <div>
            Pending Approvals
          </div>

          <h5>
            {summary.pending}
          </h5>

        </div>

      </div>

      {/* FILTER */}

      <div
        style={{
          display: "flex",
          gap: 10,
          marginBottom: 15,
          background: "#f3f4f6",
          padding: 10,
          borderRadius: 8
        }}
      >

        <input
          className="form-control"
          placeholder="Search document no..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
        />

        <button
          className="btn btn-primary"
          onClick={loadData}
        >
          Search
        </button>

      </div>
            {/* TABLE */}

      <div className="card">

        <div className="table-responsive">

          <table className="table table-bordered table-hover mb-0">

            <thead>

              <tr>

                <th>Document No</th>

                <th>Module</th>

                <th>Entity</th>

                <th>Approval</th>

                <th>Amount</th>

                <th>Level</th>

                <th>Submitted On</th>

                <th>Actions</th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="8"
                    className="text-center"
                  >
                    Loading...
                  </td>

                </tr>

              )}

              {!loading &&
                filtered.length === 0 && (

                <tr>

                  <td
                    colSpan="8"
                    className="text-center"
                  >
                    No pending approvals found
                  </td>

                </tr>

              )}

              {!loading &&
                filtered.map((row) => (

                <tr
                  key={
                    row.transaction_id
                  }
                >

                  <td>
                    {row.entity_number}
                  </td>

                  <td>
                    {row.module_code}
                  </td>

                  <td>
                    {row.entity_name}
                  </td>

                  <td>
                    {row.approval_name}
                  </td>

                  <td>
                    {formatQuantity(
                      row.amount
                    )}
                  </td>

                  <td>
                    {row.level_name}
                  </td>

                  <td>
                    {row.submitted_at
                      ? formatDate(
                          row.submitted_at
                        )
                      : "-"}
                  </td>

                  <td>

                    <button
                      className="btn btn-link btn-sm"
                      onClick={() =>
                        handleView(
                          row
                        )
                      }
                    >
                      View
                    </button>

                    <button
                      className="btn btn-link btn-sm text-success"
                      onClick={() =>
                        openApproveModal(
                          row
                        )
                      }
                    >
                      Approve
                    </button>

                    <button
                      className="btn btn-link btn-sm text-danger"
                      onClick={() =>
                        openRejectModal(
                          row
                        )
                      }
                    >
                      Reject
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

      {/* PO VIEW DRAWER */}

      {showView &&
        selectedPO && (

        <POViewDrawer
          poId={selectedPO}
          onClose={() => {

            setShowView(false);

            setSelectedPO(
              null
            );

          }}
        />

      )}

      {/* APPROVE / REJECT MODAL */}

      {showActionModal && (

        <div
          style={{
            position: "fixed",
            inset: 0,
            background:
              "rgba(0,0,0,0.4)",
            zIndex: 9999,
            display: "flex",
            justifyContent:
              "center",
            alignItems:
              "center"
          }}
        >

          <div
            className="card"
            style={{
              width: 500
            }}
          >

            <div className="card-header fw-bold">

              {actionType ===
              "APPROVE"
                ? "Approve Transaction"
                : "Reject Transaction"}

            </div>

            <div className="card-body">

              <div className="mb-3">

                <label className="form-label">

                  Remarks

                  {actionType ===
                    "REJECT" &&
                    " *"}

                </label>

                <textarea
                  className="form-control"
                  rows="4"
                  value={remarks}
                  onChange={(e) =>
                    setRemarks(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

            <div className="card-footer text-end">

              <button
                className="btn btn-secondary me-2"
                onClick={() =>
                  setShowActionModal(
                    false
                  )
                }
              >
                Cancel
              </button>

              <button
                className={
                  actionType ===
                  "APPROVE"
                    ? "btn btn-success"
                    : "btn btn-danger"
                }
                onClick={
                  handleAction
                }
              >

                {actionType ===
                "APPROVE"
                  ? "Approve"
                  : "Reject"}

              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default MyApprovalsPage;